import { ColorDynamic } from '@superdispatch/ui';
import { createSvgIcon } from './IconUtils';

export const LocationIcon = createSvgIcon(
  'LocationIcon',
  <path
    d="M7.99996 1.33333C5.19996 1.33333 2.66663 3.47999 2.66663 6.79999C2.66663 8.91999 4.29996 11.4133 7.55996 14.2867C7.81329 14.5067 8.19329 14.5067 8.44663 14.2867C11.7 11.4133 13.3333 8.91999 13.3333 6.79999C13.3333 3.47999 10.8 1.33333 7.99996 1.33333ZM7.99996 8C7.26663 8 6.66663 7.4 6.66663 6.66666C6.66663 5.93333 7.26663 5.33333 7.99996 5.33333C8.73329 5.33333 9.33329 5.93333 9.33329 6.66666C9.33329 7.4 8.73329 8 7.99996 8Z"
    fill={ColorDynamic.Dark100}
  />,
  { viewBox: '0 0 16 16' },
);
